import request from "@/utils/request";
import { ENABLE_API_DBG } from "@/appConfig.js";

function list(params) {
  const newParams = { ...params };
  if (newParams.max) {
    newParams.take = newParams.max;
    delete newParams.max;
  }
  if (newParams.offset) {
    newParams.skip = newParams.offset;
    delete newParams.offset;
  }

  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }

  const url = `/channel-organization-whitelist?${qsParams.toString()}`;
  ENABLE_API_DBG && console.log(`api.chnlOrgWhitelist.list: url = ${url}`);

  return request({
    url,
    method: "get",
    data: newParams,
  });
}

function get(itemId) {
  return request({
    url: `/channel-organization-whitelist/${itemId}`,
    method: "get",
  });
}

function addWhiteOrg(params) {
  ENABLE_API_DBG && console.log(`api.chnlOrgWhitelist.addWhiteOrg: params = ${JSON.stringify(params)}`);
  return request({
    url: `/channel-organization-whitelist`,
    method: "post",
    data: params,
  });
}

function update(params) {
  return request({
    url: `/channel-organization-whitelist/${params.id}`,
    method: "patch",
    data: params,
  });
}

function removeWhiteOrg(itemId) {
  const url = `/channel-organization-whitelist/${itemId}`;
  ENABLE_API_DBG &&
    console.log(`api.chnlOrgWhitelist.removeWhiteOrg: url = ${url}`);
  return request({
    url,
    method: "delete",
  });
}
export default {
  list,
  addWhiteOrg,
  update,
  removeWhiteOrg,
  get,
};
